import { useCallback, useMemo, useState } from "react";
import { promiseTransfer } from "./promiseTransfer";

export type FactoryDialogProps<T> = {
  open: boolean;
  onDone: (v: Promise<T | null>) => void;
};
type TriggerFn<T> = () => Promise<T | null>;
export function useFactoryDialog<T>() {
  const [open, setOpen] = useState(false);
  const [onDone, setOnDone] = useState<(v: Promise<T | null>) => void>(() => () => {});

  const trigger: TriggerFn<T> = useCallback(() => {
    const [from, p] = promiseTransfer<T | null>();

    setOpen(true);
    setOnDone(() => from);

    return p.finally(() => setOpen(false));
  }, [setOnDone, setOpen]);

  const props: FactoryDialogProps<T> = useMemo(
    () => ({
      open,
      onDone,
    }),
    [open, onDone],
  );

  return [props, trigger] as const;
}
